import React from "react";
import { useRenderTarget, RenderTarget } from "./renderTarget";
import { getPdfRenderer } from "../../getPdfRenderer";

export const RBr: React.FC = () => {
    const target = useRenderTarget();

    if (target === RenderTarget.web) {
        return <br />;
    }


    const pdf = getPdfRenderer();
    if (!pdf) return null;

    const { Text } = pdf;    // Für PDF: Text mit explizitem Line-Break
    return <Text style={{ fontSize: 0, lineHeight: 1 }}>
        {"\n"}
    </Text>;
};

RBr.displayName = "RBr";
